import { getPhoneLast4 } from '@/lib/auth/mask'

export type VerificationStep = 'email' | 'phone'

const VT_TOKEN_KEY = 'verificationToken'
const VT_STEP_KEY = 'abk_vt_step'
const VT_EMAIL_KEY = 'abk_vt_email'
const VT_NAME_KEY = 'abk_vt_name'
const VT_SURNAME_KEY = 'abk_vt_surname'
const VT_PHONE_LAST4_KEY = 'abk_vt_phone_last4'
const VT_PHONE_COUNTRY_CODE_KEY = 'abk_vt_phone_country_code'
const VT_LEGACY_PHONE_KEY = 'abk_vt_phone'

export interface VerificationState {
  readonly token: string | null
  readonly step: VerificationStep | null
  readonly email: string | null
  readonly name: string | null
  readonly surname: string | null
  /** Sufijo autenticado en el 403 de login o derivado del registro. */
  readonly phoneLast4: string | null
  readonly phoneCountryCode: string | null
}

export const getVerificationState = (): VerificationState => ({
  token: sessionStorage.getItem(VT_TOKEN_KEY),
  step: sessionStorage.getItem(VT_STEP_KEY) as VerificationStep | null,
  email: sessionStorage.getItem(VT_EMAIL_KEY),
  name: sessionStorage.getItem(VT_NAME_KEY),
  surname: sessionStorage.getItem(VT_SURNAME_KEY),
  phoneLast4:
    sessionStorage.getItem(VT_PHONE_LAST4_KEY) ??
    getPhoneLast4(sessionStorage.getItem(VT_LEGACY_PHONE_KEY) ?? ''),
  phoneCountryCode: sessionStorage.getItem(VT_PHONE_COUNTRY_CODE_KEY),
})

export interface SetVerificationOptions {
  readonly token: string
  readonly step: VerificationStep
  readonly email: string
  readonly name?: string
  readonly surname?: string
  readonly phoneLast4?: string | null
  readonly phoneCountryCode?: string | null
}

export const setVerificationState = ({
  token,
  step,
  email,
  name,
  surname,
  phoneLast4,
  phoneCountryCode,
}: SetVerificationOptions): void => {
  sessionStorage.setItem(VT_TOKEN_KEY, token)
  sessionStorage.setItem(VT_STEP_KEY, step)
  sessionStorage.setItem(VT_EMAIL_KEY, email)
  if (name) sessionStorage.setItem(VT_NAME_KEY, name)
  if (surname) sessionStorage.setItem(VT_SURNAME_KEY, surname)
  const normalizedPhoneLast4 = phoneLast4 ? getPhoneLast4(phoneLast4) : null
  if (normalizedPhoneLast4) sessionStorage.setItem(VT_PHONE_LAST4_KEY, normalizedPhoneLast4)
  else sessionStorage.removeItem(VT_PHONE_LAST4_KEY)
  if (phoneCountryCode && /^\+\d{1,4}$/.test(phoneCountryCode)) {
    sessionStorage.setItem(VT_PHONE_COUNTRY_CODE_KEY, phoneCountryCode)
  } else {
    sessionStorage.removeItem(VT_PHONE_COUNTRY_CODE_KEY)
  }
  sessionStorage.removeItem(VT_LEGACY_PHONE_KEY)
}

export const updateVerificationStep = (step: VerificationStep): void => {
  sessionStorage.setItem(VT_STEP_KEY, step)
}

export const clearVerificationState = (): void => {
  sessionStorage.removeItem(VT_TOKEN_KEY)
  sessionStorage.removeItem(VT_STEP_KEY)
  sessionStorage.removeItem(VT_EMAIL_KEY)
  sessionStorage.removeItem(VT_NAME_KEY)
  sessionStorage.removeItem(VT_SURNAME_KEY)
  sessionStorage.removeItem(VT_PHONE_LAST4_KEY)
  sessionStorage.removeItem(VT_PHONE_COUNTRY_CODE_KEY)
  sessionStorage.removeItem(VT_LEGACY_PHONE_KEY)
}
